module.exports = __webpack_public_path__ + "static/img/img24.f5bf2d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aifv/img24.png
// module id = X0vw
// module chunks = 1